import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React from "react";
import { NIAOpportunityTableHeaders } from "../NiaOpportunityConstants";
import { NiaOpportunityTableData } from "../../../services/interfaces/INiaOpportunity";
import { NIAOpportunityLabels as LABELS } from "../NiaOpportunityConstants";
import { Whisper, Tooltip, Col } from "rsuite";
import InfoOutlineIcon from "@rsuite/icons/InfoOutline";
import { numberFormatter } from "../../../utils/formatter";

interface INiaOppVendorsListProps {
  vendorList?: NiaOpportunityTableData[];
  spendYear?: string;
  vendorSelected?: NiaOpportunityTableData;
  setVendorSelected: (value: NiaOpportunityTableData | undefined) => void;
  handleVendorSelected: (value: NiaOpportunityTableData) => void;
}

const NiaOppVendorsList = ({
  vendorList,
  spendYear,
  vendorSelected,
  setVendorSelected,
  handleVendorSelected,
}: INiaOppVendorsListProps) => {
  const VendorTemplate = (rowData: NiaOpportunityTableData) => {
    if (rowData?.contract_info?.length > 0) {
      return (
        <div className="flex flex-row justify-between items-center w-full">
          <span>{rowData?.vendor}</span>
          <span>
            <Whisper
              speaker={
                <Tooltip
                  placement="auto"
                  className="nia-opportunity-category-peer-table bg-white p-2"
                >
                  <DataTable
                    rowGroupMode="rowspan"
                    groupRowsBy="contract_end"
                    value={rowData.contract_info}
                    stripedRows
                    scrollable
                    scrollHeight="100%"
                    showGridlines
                    emptyMessage="No data found corresponding to selected commodity."
                  >
                    <Column field="commodity" header={"Commodity"} />
                    <Column field="contract_end" header={"Contract End"} />
                  </DataTable>
                </Tooltip>
              }
            >
              <InfoOutlineIcon
                style={{
                  fontSize: "1.3vh",
                  color: "grey",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              />
            </Whisper>
          </span>
        </div>
      );
    }
    return rowData?.vendor;
  };

  return (
    <div className="flex flex-col gap-4 justify-start items-start basis-[47%] shrink-0 h-full">
      <div className="w-full nia-opportunity-table h-full max-h-[75.75vh]">
        <DataTable
          value={vendorList}
          stripedRows
          scrollable
          scrollHeight="75.75vh"
          showGridlines
          emptyMessage="No data found corresponding to selected commodity."
          selectionMode={"single"}
          selection={vendorSelected!}
          dataKey={"vendor"}
          removableSort
          onSelectionChange={(event) => handleVendorSelected(event.value)}
          isDataSelectable={(event) => event.data.opportunity !== 0}
          rowClassName={(rowData) =>
            rowData.opportunity !== 0 ? "cursor-pointer" : "cursor-not-allowed"
          }
        >
          {NIAOpportunityTableHeaders.map((column, index) => (
            <Column
              key={column.field}
              field={column.field}
              sortable
              headerStyle={column.field === "vendor" ? { minWidth: "7vw" } : {}}
              header={
                <div className="flex justify-start items-center">
                  {column.field === LABELS.previousSpendColumnField
                    ? `${spendYear} ${column.header}`
                    : column.header}
                </div>
              }
              bodyStyle={column.field === "vendor" ? { maxWidth: "11vw" } : {}}
              body={(rowdata) => {
                return (
                  <>
                    {column.field === "opportunity" ||
                      column.field === "spend" ? (
                      column.field === "spend" ? (
                        <div className="flex justify-between items-center w-full">
                          {`$${rowdata["overall_projected_spend"]?.toFixed(
                            1
                          )}M`}
                        </div>
                      ) : (
                        <div className="flex justify-between items-center w-full">
                          {`${numberFormatter(rowdata[column.field], 1, "$")}`}
                        </div>
                      )
                    ) : column.field === "vendor" ? (
                      VendorTemplate(rowdata)
                    ) : (
                      <div className="flex justify-between items-center w-full">
                        {rowdata[column.field] !== null
                          ? `${rowdata[column.field]}%`
                          : "-"}
                      </div>
                    )}
                  </>
                );
              }}
            />
          ))}
        </DataTable>
      </div>
    </div>
  );
};

export default NiaOppVendorsList;
